export const DMAT_SET_OVERVIEW = "DMAT_SET_OVERVIEW";
export const DMAT_SET_LOADING = "DMAT_SET_LOADING";
export const DMAT_SET_LOAD_ERROR = "DMAT_SET_LOAD_ERROR";
